import React from "react";
import AddPlan from "./DashAdmin/AddPlan";

const SubscriptionPlanModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-60 flex justify-center items-center">
      <div
        className="relative bg-white bg-opacity-10 backdrop-blur-lg rounded-2xl p-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto shadow-lg border border-white/20"
      >
        <button
          className="absolute top-4 right-4 text-white text-xl z-10"
          onClick={onClose}
        >
          ✕
        </button>
        <div className="pt-10">
          <AddPlan onSuccess={onClose} />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlanModal;

